module.exports = __webpack_public_path__ + "img/no-data.a8c6d02.png";